module.exports = __webpack_public_path__ + "img/totally-radio-hits.d4ac0533.png";